import React from 'react';

import { ClickableIcon, SectionCard } from '~components';
import Icon, { faExpand, faInfoCircle } from '~components/icon';
import { Column, Row, TableView } from '~components/table-view';

interface ComponentProps {
  title: string;
  description: string;
  columns: Column[];
  data: Row[];
  dataCy: string;
  onExpand?: () => void;
}

export const DashboardTable: React.FC<ComponentProps> = ({ title, description, columns, data, dataCy, onExpand }) => {
  return (
    <SectionCard
      title={title}
      description={description}
      className="dashboard-table"
      headerRight={
        onExpand ? (
          <ClickableIcon
            icon={faExpand}
            id={`${dataCy}-expand`}
            onClick={onExpand}
            toolTip="View full table"
            ariaLabel={`Expand ${title}`}
          />
        ) : undefined
      }
    >
      {data.length > 0 ? (
        <TableView id={dataCy} data={data} columns={columns} readonly />
      ) : (
        <div className="no-data" role="status">
          <Icon icon={faInfoCircle} />
          No data available for the selected period.
        </div>
      )}
    </SectionCard>
  );
};
